import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _Parser___init__impl__gdyfby2rzvqqjkmwt8g as _Parser___init__impl__gdyfby,
  Parser__match$default_impl_x2xlti3tbegi3v1b9ik as Parser__match$default_impl_x2xlti,
  ParseException603g9fc07eag as ParseException,
} from '../internal/format/parser/Parser.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from '../Exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractDateTimeFormatClass;
function AbstractDateTimeFormat() {
  if (AbstractDateTimeFormatClass === VOID) {
    class $ {
      format_l1mq08_k$(value) {
        // Inline function 'kotlin.also' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        this.get_actualFormat_d0ha3y_k$().formatter_tykoui_k$().format$default_fwaxfk_k$(this.intermediateFromValue_816pep_k$(value), this_0);
        return this_0.toString();
      }
      parse_xovy9i_k$(input) {
        var tmp;
        try {
          tmp = Parser__match$default_impl_x2xlti(_Parser___init__impl__gdyfby(this.get_actualFormat_d0ha3y_k$().parser_ggn3z5_k$()), input, this.get_emptyIntermediate_lysuyr_k$());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof ParseException()) {
            var e = $p;
            throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_zeum51_k$("Failed to parse value from '" + toString(input) + "'", e);
          } else {
            throw $p;
          }
        }
        var matched = tmp;
        try {
          return this.valueFromIntermediate_60ox3m_k$(matched);
        } catch ($p_0) {
          if ($p_0 instanceof IllegalArgumentException()) {
            var e_0 = $p_0;
            var message = e_0.message;
            throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_zeum51_k$(message == null ? "The value parsed from '" + toString(input) + "' is invalid" : '' + message + " (when parsing '" + toString(input) + "')", e_0);
          } else {
            throw $p_0;
          }
        }
      }
    }
    initMetadataForClass($, 'AbstractDateTimeFormat');
    AbstractDateTimeFormatClass = $;
  }
  return AbstractDateTimeFormatClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Padding_NONE_instance = new (Padding())('NONE', 0);
  Padding_ZERO_instance = new (Padding())('ZERO', 1);
  Padding_SPACE_instance = new (Padding())('SPACE', 2);
}
var Padding_NONE_instance;
var Padding_ZERO_instance;
var Padding_SPACE_instance;
var PaddingClass;
function Padding() {
  if (PaddingClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Padding');
    PaddingClass = $;
  }
  return PaddingClass;
}
function Padding_NONE_getInstance() {
  static_init();
  return Padding_NONE_instance;
}
function Padding_ZERO_getInstance() {
  static_init();
  return Padding_ZERO_instance;
}
function Padding_SPACE_getInstance() {
  static_init();
  return Padding_SPACE_instance;
}
//region block: exports
export {
  Padding_NONE_getInstance as Padding_NONE_getInstance3hrh9czbcdldi,
  Padding_SPACE_getInstance as Padding_SPACE_getInstance3jytkjkv2jvr6,
  Padding_ZERO_getInstance as Padding_ZERO_getInstance165tawgk9tdj7,
  AbstractDateTimeFormat as AbstractDateTimeFormat1er9ki1vjeb1b,
};
//endregion

//# sourceMappingURL=DateTimeFormat.mjs.map
